import { ErrorsType } from '@src/types/errors';

import { LoadersType } from '@modules/builders';
import { FiatCurrencyEnum } from '@modules/global/types';
import { TSortTransactions } from '@modules/transactions/types';

import { asyncActions } from './actions';
import { AccountCreateStatus, AccountsLimitsResponse, AccountsResponse } from './types';

export type AccountsStateType = {
  limits?: AccountsLimitsResponse;
  loaders: LoadersType<typeof asyncActions>;
  errors: ErrorsType;
  verification?: {
    key?: string;
    code_length?: number;
    timeout?: number;
  };
  iban?: string;
  iban_currency: FiatCurrencyEnum;
  details: AccountsResponse[];
  transactions: TSortTransactions;
  createAccountStatus?: AccountCreateStatus;
};

export const initialState: AccountsStateType = {
  loaders: {},
  errors: {},
  iban: '11111',
  iban_currency: FiatCurrencyEnum.EUR,
  details: [],
  transactions: {},
};

export enum AccountsOperationsEnum {
  buy = 'buy',
  sell = 'sell',
  fiat_sell = 'fiat_sell',
  fiat_buy = 'fiat_buy',
  fiat_withdraw = 'fiat_withdraw',
}

export default initialState;
